import {createAction, Action} from './createAction';

let number = 0;

export type ActionCreator<T extends Action | string> = T extends Action
    ? {
        (...args: any[]): T
        type: T['type']
        toString(): T['type']
    }
    : (T extends string
        ? {
            (...args: any[]): Action
            type: T
            toString(): T
        }
        : never)

export function createActionCreator<TCallable extends <_T>(...args: any[]) => Action>(
    executor: (
        resolve: <Payload = undefined, Meta = undefined>(
            payload?: Payload,
            meta?: Meta,
        ) => Action<Payload, Meta>,
    ) => TCallable = resolve => (() => resolve()) as TCallable,
) {
    number += Math.floor(Math.random() * 100) + 1;
    const type = createType(number);
    const callable = executor((payload, meta) =>
        createAction(type, payload!, meta!),
    );

    return Object.assign(callable, {
        type,
        toString() {
            return type;
        },
    });
}

function createType(number: number) {
    let str = number.toString(16);
    return [...Array(17 - str.length).fill(0), ...str.split('')].join('');
}
